const ACTIVATE_PRODUCT_COMPARE = 'ACTIVATE_PRODUCT_COMPARE';
export default ACTIVATE_PRODUCT_COMPARE;
